import React from "react"
import {
  Col,
  Drawer,
  Form,
  Input,
  Radio,
  Row,
  Upload,
  notification,
} from "antd"
import { UploadOutlined } from "@ant-design/icons"
import { Button } from "src/components/actions/button"
import { CloseSvg, SaveSvg } from "src/components/Svg"
import { useAppData } from "src/store/app-data"
import api from "src/api"
import styled from "styled-components"

export function CreateSegmentDrawer({ onClose, onSuccess }) {
  const layoutConfig = useAppData((state) => state.layoutConfig)
  const [form] = Form.useForm()
  const [isSubmitting, setIsSubmitting] = React.useState(false)

  async function onSubmit(values) {
    setIsSubmitting(true)
    try {
      const formData = new FormData()
      formData.append("title", values.title)
      formData.append("lookupType", values.lookupType)
      formData.append("file", values.file.file)

      await api.post("segments", formData, {
        useMailingApi: true,
        headers: { "Content-Type": "multipart/form-data" },
      })

      notification.success({ message: "Сегмент создан" })
      form.resetFields()
      onSuccess()
    } catch (error) {
      console.error("Ошибка создания сегмента", error)
      notification.error({ message: "Ошибка создания сегмента" })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <DrawerEdit
      width={layoutConfig.isMobile ? "90%" : "50%"}
      title="Новый сегмент"
      onClose={onClose}
      open
    >
      <FormEdit form={form} layout="vertical" onFinish={onSubmit}>
        <StyledFormItem
          label="Название"
          name="title"
          rules={[{ required: true, message: "Введите название" }]}
        >
          <Input placeholder="Например: Сегмент для акции" />
        </StyledFormItem>

        <StyledFormItem
          label="Тип идентификатора в файле"
          name="lookupType"
          initialValue="phone"
          rules={[{ required: true }]}
        >
          <Radio.Group buttonStyle="solid">
            <Radio.Button value="phone">Телефон</Radio.Button>
            <Radio.Button value="guid">GUID</Radio.Button>
          </Radio.Group>
        </StyledFormItem>

        <StyledFormItem
          label="CSV файл"
          name="file"
          rules={[{ required: true, message: "Загрузите файл" }]}
        >
          <Upload
            beforeUpload={() => false}
            maxCount={1}
            accept=".csv,.txt"
          >
            <Button icon={<UploadOutlined />}>Выбрать файл</Button>
          </Upload>
        </StyledFormItem>

        <HintText>
          Файл должен содержать по одному телефону или GUID на каждой строке
        </HintText>

        <ButtonRow>
          <ButtonCol>
            <Button onClick={onClose} icon={<CloseSvg />}>
              Закрыть
            </Button>
          </ButtonCol>
          <ButtonCol>
            <Button
              icon={<SaveSvg />}
              type="primary"
              htmlType="submit"
              loading={isSubmitting}
            >
              Создать
            </Button>
          </ButtonCol>
        </ButtonRow>
      </FormEdit>
    </DrawerEdit>
  )
}

const DrawerEdit = styled(Drawer)``
const FormEdit = styled(Form)``
const StyledFormItem = styled(Form.Item)`margin-bottom: 16px;`
const ButtonCol = styled(Col)`padding-bottom: 5px;`
const ButtonRow = styled(Row)`
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
  .ant-col { margin-left: 0.4em; }
`
const HintText = styled.div`
  color: #888;
  font-size: 12px;
  margin-bottom: 16px;
`
